import React from 'react';
import ScoreMessage from '../scoreMessage';

const CommonWrapper = () => {
  return (
    <>
    <ScoreMessage />
    </>
  );
};

export default CommonWrapper;
